import React, { useEffect, useMemo } from 'react';
import {Box, TextInput} from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import Fuse from 'fuse.js';

type Props<T = any> = {
    videos: T[];
    value: string;
    onChangeValue: (v: string) => void;
    setSearchResults: (arr: T[]) => void;
};

export const SearchBar = <T extends { title?: string; subtitle?: string }>({
                                                                               videos,
                                                                               value,
                                                                               onChangeValue,
                                                                               setSearchResults,
                                                                           }: Props<T>) => {
    const [debounced] = useDebouncedValue(value, 250);

    const fuse = useMemo(
        () =>
            new Fuse(videos, {
                keys: ['title', 'subtitle'],
                threshold: 0.35,
                minMatchCharLength: 2,
                ignoreLocation: true,
            }),
        [videos]
    );

    useEffect(() => {
        const q = debounced.trim();
        if (!q) {
            setSearchResults(videos);
            return;
        }
        const result = fuse.search(q).map((r) => r.item);
        setSearchResults(result);
    }, [debounced, fuse, videos, setSearchResults]);

    return (
        <Box mb={'1rem'}>
            <TextInput
                value={value}
                onChange={(e) => onChangeValue(e.currentTarget.value)}
                placeholder="Search videos…"
                aria-label="Search videos"
            />
        </Box>
    );
};
